import { render, staticRenderFns } from "./OrderTransactions.vue?vue&type=template&id=81b2682c&"
import script from "./OrderTransactions.vue?vue&type=script&lang=ts&"
export * from "./OrderTransactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports